import React from "react";
import { useTranslation } from "react-i18next";
import TwitterIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import './footer.css';


const Footer=()=>{
    const { t } = useTranslation('common');
    return (
<div className="footer">
<div className="sb__footer section__padding">
    <div className="sb__footer-links">
        {/* <div className="sb__footer-links-div">
            <h4>Contact</h4>
            <a className="belowa" href="/Follow">
                <p>hello@XSubscribe.com</p>
            </a>
        </div> */}
        <div className="sb__footer-links-div">
            <h4>{t('company')}</h4>
            <a className="belowa" href="/about">
                <p>{t('about')}</p>
            </a>
            <a className="belowa" href="/press">
                <p>{t('press')}</p>
            </a>
            <a className="belowa" href="mailto:xsubscribe.bio@gmail.com">
                <p>{t('contact')}</p>
            </a>
        </div>

        <div className="sb__footer-links-div">
            <h4>{t('followUs')}</h4>
            <div className="socialmedia">
            <a href="https://x.com/Xsubscribebio" style={{ margin: '0 3px' , color: 'white'}}>
            <TwitterIcon />
        </a>
        {/* <a href="https://www.instagram.com/XSubscribe.io/" style={{ margin: '0 3px' ,color: 'white'}}>
            <InstagramIcon />
        </a>
        <a href="https://facebook.com/XSubscribeFB" style={{ margin: '0 3px' ,color: 'white' }}>
            <FacebookIcon />
        </a> */}
            </div>

        </div>
    </div>
    <hr></hr>
    <div className="sb__footer-below">
        <div className="sb__footer-copyright">
            <p>
                {/* @{new Date().getFullYear} XSubscribe. All rights reserved. */}
            </p>
        </div>
        <div className="sb__footer-below-links">
            <a className="belowa" href="/terms"> <div><p>{t('termsAndConditions')}</p></div></a>
            <a  className="belowa" href="/about/cookie-notice/"> <div><p>{t('cookiePolicy')}</p></div></a>
        </div>
    </div>
</div>

</div>
    )
}

export default Footer;